<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <!-- Dark red branded fallback logo -->
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#es-logo-clip)">
      <circle cx="8" cy="8" r="8" fill="#8B1A1A" />
      <text x="8" y="11.5" text-anchor="middle" font-size="9" font-weight="bold" fill="white" font-family="system-ui, sans-serif">E</text>
    </g>
    <defs>
      <clipPath id="es-logo-clip">
        <rect width="16" height="16" rx="4" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
